import { FC } from 'react';

import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Heading,
  Stack,
} from '@chakra-ui/react';

type Faq = {
  q: string;
  a: string;
};

const faqs: Faq[] = [
  {
    q: 'When will my photos be delivered?',
    a: 'Photos are printed and sent at the end of every month.',
  },
  {
    q: 'What size are the prints?',
    a: 'Every month three 4x6 prints are delivered.',
  },
  {
    q: 'Can I change recipients?',
    a: 'Yes, you can change the recipients that the prints are delivered to at any time.',
  },
  {
    q: 'Is the service available outside of the United States?',
    a: 'Currently we only operate within the United States - please email support@joyline.io to request access in your country.',
  },
];

export const Faqs: FC = () => {
  return (
    <Stack as='section' spacing={4}>
      <Heading as='h2' size='h4'>
        Search common questions
      </Heading>
      <Accordion>
        {faqs.map((faq) => (
          <AccordionItem key={faq.q}>
            <AccordionButton>
              <Box flex='1' textAlign='left'>
                <Heading as='h3' size='h5'>
                  {faq.q}
                </Heading>
              </Box>
              <AccordionIcon />
            </AccordionButton>
            <AccordionPanel pb={4}>{faq.a}</AccordionPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </Stack>
  );
};
